export enum DashboardTaskDateRange {
  LastWeek = 'LAST_WEEK',
  LastMonth = 'LAST_MONTH',
  OlderThanMonth = 'OLDER_THEN_MONTH',
}
